import { ISupplierPagedRequest } from '../../../../model/sge/supplier/request/supplier-paged-request';
import { ISupplierResponse } from '../../../../model/sge/supplier/response/supplier-response';
import { ICountryResponse } from '../../../../model/base/location-response';

export type SupplierSearchState = {
    parameters: ISupplierPagedRequest;
    searchTrigger: number;
    countries: ICountryResponse[];
    drawer: { open: boolean; record?: ISupplierResponse };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
    setCountries = 'setCountries',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
}

export const SupplierSearchReducer = (state: SupplierSearchState, action: any): SupplierSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.setCountries:
            return { ...state, countries: payload };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, record: payload } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
